<div class="row k-justify-content-center">
  <div class="wraper" style="width: 95%;">
    <div class="row">
      <div class="overlay" *ngIf="loading">
        <div class="spinner-wrapper">
          <app-spinner>
            <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
          </app-spinner>
        </div>
      </div>
      <div class="col-12">
        <div *ngIf="editRequisitionFlag else requisitionInfo">
          <app-receiving-edit-requisition (updateDone)="reqRequisitionUpdated()" packageDeliveredDate="{{packageDeliveredDate}}"
                                          (updateFailed)="reqRequisitionUpdateFailed($event)" (cancelled)="cancelEditRequisition()">
          </app-receiving-edit-requisition>
        </div>
        <ng-template #requisitionInfo pTemplate="content">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-4">
                  Requisition - {{requisition.Accession}}
                </div>
                <div class="col-3">
                  <span>
                    Status: {{requisition.Status}} <small>as of  {{requisition.StatusDate | date:'short'}} </small>
                    <a (click)="showStatusHistory = true;" class="iconbutton" title="Show Status History">
                      <i class="fal fa-history"></i>
                    </a>
                  </span>
                </div>
                <div class="col-5">
                  <div class="float-right">
                    <a *hasClaim="'Requisition_Edit'" [hidden]="requisition.Status == 'Completed' || requisition.IsRejected"
                       [ngClass]="(disableSampleInfoEdit) ? 'disabled' : ''"
                       (click)="editRequisition()" class="iconbutton" title="Edit">
                      <i class="far fa-edit"></i>
                    </a>
                    <a (click)="getRequisitionDoc()" class="iconbutton" title="Get Requisition PDF">
                      <i class="far fa-print"></i>
                    </a>
                    <a *hasClaim="'PackageReq_Edit'" [hidden]="!requisition.Accession || requisition.IsRejected || !canReject"
                       (click)="displayRejectDialog('req', -1)" class="iconbutton" title="Reject Requisition">
                      <i class="far fa-thumbs-down"></i>
                    </a>
                    <a *hasClaim="'PackageReq_Archive'"
                       [hidden]="!requisition.Accession || requisition.SpecimenSerialNumber || (requisitionRack && requisitionRack.RackSerialNumber)"
                       (click)="deleteRequisition()" class="iconbutton" title="Delete Requisition">
                      <i class="far fa-trash-alt"></i>
                    </a>
                    <a *hasClaim="'PackageReq_Archive'" [hidden]="!requisition.Accession || requisition.HasExceptions"
                       (click)="sendRequisitionToIntegrations()" class="iconbutton" title="Re-try Integration">
                      <i class="fal fa-arrow-from-left"></i>
                    </a>
                    <a *hasClaim="'PackageReq_Admin'" [hidden]="!requisition.Accession || !canUpdate"
                       (click)="updateOrder()" class="iconbutton" title="Refresh Order">
                      <i class="fal fa-arrow-circle-down"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <div>
                    <label>Name: </label> {{requisition.FirstName}} {{requisition.LastName}}
                  </div>
                  <div>
                    <label>Birthdate: </label> {{requisition.BirthDate | date:'shortDate'}}
                    <label class="margin-left-15">Gender: </label> {{genderDescription}}
                  </div>
                  <div>
                    <label>Race: </label> {{requisition.Race}}
                    <label class="margin-left-15">Ethnicity: </label> {{requisition.Ethnicity}}
                  </div>
                  <div>
                    <label>MRN: </label> {{requisition.MRN}}
                  </div>
                  <div>
                    <label>Address: </label> {{requisition.Address1}}
                  </div>
                  <div [hidden]="!requisition.Address2">
                    <label>Address 2: </label> {{requisition.Address2}}
                  </div>
                  <div>
                    <label>City/State: </label> {{requisition.City}} {{requisition.State}} {{requisition.Zip}}
                  </div>
                  <div>
                    <label>Email: </label> {{requisition.Email}}
                    <label class="margin-left-15">Phone: </label> {{requisition.Phone}}
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <label>Client: </label> {{requisition.ClientName}}
                  </div>
                  <div>
                    <label>Facility: </label> {{requisition.FacilityCode}} - {{requisition.FacilityName}}
                  </div>
                  <div>
                    <label>Provider: </label> {{requisition.ProviderName}} <span [hidden]="requisition.ProviderNPI==null">({{requisition.ProviderNPI}})</span>
                  </div>
                  <div class="card margin-top-20" [hidden]="requisition.RequisitionExceptions.length == 0">
                    <div class="card-header">
                      Exceptions
                      <div class="float-right">
                        <a *hasClaim="'Resolve_Edit'" [hidden]="!requisition.HasExceptions"
                           (click)="attemptToResolveRequisitionExceptions()" class="iconbutton" title="Resolve Exception">
                          <i class="fas fa-laptop-medical"></i>
                        </a>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row" *ngFor="let x of requisition.RequisitionExceptions">
                        <div class="col-12 pl-4" [ngClass]="{'strikethrough': x.Resolved}">
                          {{x.IssueDescription}}
                          <a *ngIf="x.ExceptionType==4 && !x.Resolved && requisition.OrderSource && !isInterVenn"
                             (click)="resolveLabelMismatchException()" title="Resolve Label Mismatch"
                             style="cursor: pointer; margin-left: 10px;">
                            <i class="fas fa-user-check"></i>
                          </a>
                        </div>

                      </div>
                      <div class="row">
                        <div class="col-12 pl-4" [hidden]="!requisition.HasExceptions">
                          <label>Resolve Location: </label>
                          <span [hidden]="requisitionRack"> Not in a rack</span>
                          <span *ngIf="requisitionRack">
                            {{requisitionRack.RackSerialNumber}} - {{requisitionRack.Row | rackLocation: requisitionRack.Col}}
                          </span>
                        </div>
                      </div>
                      <div class="row" [hidden]="!requisition.HasRequisitionRackHistory" *ngFor="let x of requisition.RequisitionRackHistory">
                        <div class="col-12 pl-4">
                          <small> {{x.StatusDate | date:'M/d/yy h:mm a'}} {{x.RackSerialNumber}} {{x.Row  | rackLocation: x.Col}} {{x.StatusText}} {{x.StatusUser ? "by "+x.StatusUser: ""}}</small>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="col-4">
                  <div>
                    <label>Ordered: </label> {{requisition.LabPanelName}}
                  </div>
                  <div>
                    <label>Code: </label> {{requisition.OrderCode}}
                  </div>
                  <div>
                    <label>Specimen Type: </label> {{requisition.SpecimenTypeCode}} - <small>{{requisition.SpecimenTypeName}}</small>
                  </div>
                  <div>
                    <label>Collected: </label> {{requisition.DateOfService | date:'short'}}<small> by {{requisition.SpecimenCollectedBy}}</small>
                  </div>
                  <div class="row" [hidden]="!requisition.IsRejected">
                    <div class="col-12 text-danger">
                      <h4>REJECTED</h4>
                    </div>
                  </div>
                  <div class="row" *ngFor="let x of requisition.RequisitionRejections">
                    <div class="col-12">
                      <label class="text-danger margin-bottom-5"
                             [ngClass]="{'strikethrough': x.Unrejected}">{{x.RejectionTypeName}}</label>
                      <a *hasClaim="'PackageReq_Edit'" [hidden]="x.Unrejected || x.RejectionType == 3"
                         (click)="showUnreject(x,'req')" class="ml-4 iconbutton" title="Un Reject">
                        <i class="far fa-thumbs-up"></i>
                      </a>
                      <span *hasClaim="'PackageReq_Edit'" [hidden]="x.Unrejected || x.RejectionType != 3"
                            title="QNS rejections cannot be unrejected" class="ml-4 disabled" disabled="disabled">
                        <i class="far fa-thumbs-up"></i>
                      </span>
                    </div>
                    <div class="col-12">
                      <small class="float-right">
                        Rejected on {{x.CreatedDate | date:'short'}} by {{x.CreatedBy}}
                        <span [hidden]="!x.Description" title="{{x.Description}}">
                          <i class="far fa-comment-dots"></i>
                        </span>
                      </small>
                    </div>
                    <div class="col-12 float-right" [hidden]="!x.Unrejected">
                      <small class="float-right">
                        Unrejected on {{x.UnrejectedDate | date:'short'}} by
                        {{x.UnrejectedBy}}
                        <span [hidden]="!x.UnrejectDescription" title="{{x.UnrejectDescription}}">
                          <i class="far fa-comment-dots"></i>
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="col-12">
        <div class="card mt-4" [hidden]="!requisition.SpecimenSerialNumber || isInterVenn">
          <div class="card-header">
            MedTek21 Information
            <div class="float-right">
              <a *hasClaim="'Requisition_Edit'" (click)="getMedTek21Data()" class="iconbutton"
                 title="Show MedTek21 Data"><i class="fal fa-cloud-download"></i></a>
            </div>
          </div>
          <div class="card-body" [hidden]="!orderNotFound">
            <div class="text-danger">
              <h6>{{orderNotFound}}</h6>
            </div>
          </div>
          <div class="card-body" [hidden]="!order?.OrderId">
            <div>
              <label>Name: </label> {{order.PatientFirstName}} {{order.PatientLastName}}
            </div>
            <div>
              <label>Birthdate: </label> {{order.PatientBirthDate | date:'longDate'}}
            </div>
            <div>
              <label>Gender: </label> {{order.PatientGender}}
            </div>
            <div>
              <label>Facility: </label> {{order.FacilityCode}} - {{order.FacilityName}}
            </div>
            <div>
              <label>Status: </label> {{order.StatusDisplay}} <small>{{order.StatusDate | date:'short'}}</small>
            </div>
            <div [hidden]="!order.LabTestResultText">
              <label>Result: </label> {{order.LabTestResultText}} <small>{{order.ResultedDate | date:'short'}}</small>
            </div>
            <div [hidden]="order.LabTestResultText || !order.PrelimLabTestResultText">
              <label>Prelim Result: </label> {{order.PrelimLabTestResultText}}
            </div>
          </div>
        </div>
        <div class="col-12" *ngFor="let x of requisition.RequisitionTests">
          <div class="card mt-4">
            <div class="card-header">
              <div class="row">
                <div class="col-4">
                  {{x.LabTestName}}
                </div>
                <div class="col-4" [hidden]="!securityService.hasClaim('Requisition_View_Status')">
                  <span [hidden]="!x.Status">
                    Status: {{x.Status}} <small>as of  {{x.StatusDate | date:'short'}}</small>
                    <a (click)="loadRequisitionTestStatusHistory(x.Id)" class="iconbutton" title="Show Test Status History">
                      <i class="fal fa-history"></i>
                    </a>
                  </span>
                </div>
                <div class="col-4" [hidden]="!securityService.hasClaim('Requisition_View_Status')">
                  <div class="float-right">
                    <a *hasClaim="'PackageReq_Edit'" [hidden]="x.IsRejected || !canReject"
                       (click)="displayRejectDialog('reqTest', x.Id)" class="iconbutton" title="Reject Test">
                      <i class="far fa-thumbs-down"></i>
                    </a>
                    TAT: {{(x.TATMinutes ? x.TATMinutes/60 : 0.0) | number:'1.1-1'}} hours
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-7" [hidden]="x.IsRejected">
                  <div class="col-12 text-danger" [hidden]="x.Status != 'Not Applicable'">
                    Not Applicable
                  </div>
                  <div *ngFor="let a of sortTestResults(x.RequisitionTestResults); index as i">
                    <div class="row">
                      <div class="col-12">
                        <label [hidden]="i != 0">Completed: </label>
                        <label [hidden]="i == 0">Previous: </label>
                        {{a.ReportDate | date:'short' }}
                        <label>Result: </label> {{a.ResultText}}
                        <label>By: </label> {{a.SignedBy}}
                        <a [hidden]="x.Status != 'Completed'" (click)="getRequisitionTestResultReport(a.Id)" class="iconbutton" title="Get Test Report PDF">
                          <i class="far fa-print"></i>
                        </a>
                        <a (click)="setResultComment(a.Id, a.CorrectionReason)" class="iconbutton" title="Edit Result Comment">
                          <i class="far fa-edit"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-5">
                  <div class="row" [hidden]="!x.IsRejected">
                    <div class="col-12 text-danger">
                      <label>
                        <span class="text-danger">
                          REJECTED
                        </span>
                      </label>
                      <a (click)="getRequisitionTestRejectReport(x.Id)" class="iconbutton" title="Get Reject Report PDF">
                        <i class="far fa-print"></i>
                      </a>
                    </div>
                  </div>
                  <div class="row" *ngFor="let rtr of x.RequisitionTestRejections">
                    <div class="col-12">
                      <label class="text-danger margin-bottom-5"
                             [ngClass]="{'strikethrough': rtr.Unrejected}">{{rtr.RejectionTypeName}}</label>
                      <a *hasClaim="'PackageReq_Edit'" [hidden]="rtr.Unrejected || rtr.RejectionType == 3"
                         (click)="showUnreject(rtr,'reqTest')" class="ml-4 iconbutton" title="Un Reject">
                        <i class="far fa-thumbs-up"></i>
                      </a>
                      <span *hasClaim="'PackageReq_Edit'" [hidden]="rtr.Unrejected || rtr.RejectionType != 3"
                            title="QNS rejections cannot be unrejected" class="ml-4 disabled" disabled="disabled">
                        <i class="far fa-thumbs-up"></i>
                      </span>
                    </div>
                    <div class="col-12">
                      <small class="float-right">
                        Rejected on {{rtr.CreatedDate | date:'short'}} by {{rtr.CreatedBy}}
                        <span [hidden]="!rtr.Description" title="{{rtr.Description}}">
                          <i class="far fa-comment-dots"></i>
                        </span>
                      </small>
                    </div>
                    <div class="col-12 float-right" [hidden]="!rtr.Unrejected">
                      <small class="float-right">
                        Unrejected on {{rtr.UnrejectedDate | date:'short'}} by
                        {{rtr.UnrejectedBy}}
                        <span [hidden]="!rtr.UnrejectDescription" title="{{rtr.UnrejectDescription}}">
                          <i class="far fa-comment-dots"></i>
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
    </div>
  </div>
</div>
<p-toast></p-toast>


<p-dialog [(visible)]="showStatusHistory" [modal]="true">
  <ng-template #header>
    Status History
  </ng-template>
  <div>
    <div *ngFor="let dt of requisitionStatusHistoryList">
      <label>{{dt.Status}}: </label> on {{dt.StatusDate | date:'short'}} by  {{dt.StatusBy}}
    </div>
  </div>
  <ng-template #footer>
    <button (click)="showStatusHistory = false;" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Close
    </button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showTestStatusHistory" [modal]="true">
  <ng-template #header>
    Test Status History
  </ng-template>
  <div>
    <div class="overlay" *ngIf="loadingRTSH">
      <div class="spinner-wrapper">
        <app-spinner>
          <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
        </app-spinner>
      </div>
    </div>
    <div *ngFor="let dt of requisitionTestStatusHistoryList">
      {{dt.StatusType}} - {{dt.Status}} on {{dt.StatusDate | date:'short'}} by  {{dt.StatusBy}}
    </div>
  </div>
  <ng-template #footer>
    <button (click)="showTestStatusHistory = false;" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Close
    </button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showRejectDialog" [modal]="true">
  <ng-template #header>
    Rejection Reason
  </ng-template>
  <div style="height: 275px;" [hidden]="isInterVenn">
    <label>Select reason:</label>
    <p-listbox [options]="rejectionTypes"
               [(ngModel)]="selectedRejectionType"
               [multiple]="true"
               [checkbox]="true"
               [style]="{'width':'250px'}"
               (ngModelChange)="selectedRejectionTypeChange()">
    </p-listbox>
  </div>
  <div style="height: 300px;">
    <label>Comment:</label>
    <br />
    <div style="max-height: 200px; overflow-y: hidden">
      <p-listbox [options]="rejectionComments"
                 [(ngModel)]="rejectionSelDescription"
                 [multiple]="false"
                 [checkbox]="false"
                 [style]="{'width':'400px', 'height': '195px'}"
                 (ngModelChange)="selectedRejectionCommentChange()">
      </p-listbox>
    </div>
    <textarea *ngIf="rejectionCommentOtherRequired" [(ngModel)]="rejectionDescription" size="30" [style]="{'width':'400px'}"></textarea>
    <p class="valdiation-message-small" *ngIf="rejectionCommentRequired && rejectionDescription.length < 1">* Required</p>
  </div>
  <ng-template #footer>
    <button (click)="showRejectDialog = false;" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Cancel
    </button>
    <button (click)="rejectRequisition()" class="float-right" style="margin-right:10px;margin-left:10px"
            [disabled]="selectedRejectionType.length == 0 || (rejectionCommentRequired && rejectionDescription.length < 1)">
      <i class="fa fa-save"></i> Reject
    </button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showResultComment" [modal]="true">
  <ng-template #header>
    Result Comment
  </ng-template>
  <div style="height: 100px;">
    <textarea [(ngModel)]="resultComment" size="30" [style]="{'width':'400px'}"></textarea>
  </div>
  <ng-template #footer>
    <button (click)="showResultComment = false;" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Cancel
    </button>
    <button (click)="saveResultComment()" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-save"></i> Save
    </button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showUnrejectDialog" [modal]="true">
  <ng-template #header>
    Unrejection Reason
  </ng-template>
  <div style="height: 100px;">
    <label>Comment:</label><br />
    <textarea [(ngModel)]="unrejectionDescription" size="30" [style]="{'width':'400px'}"></textarea>
  </div>
  <ng-template #footer>
    <button (click)="showUnrejectDialog = false;" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Cancel
    </button>
    <button (click)="unreject()" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-save"></i> Unreject
    </button>
  </ng-template>
</p-dialog>


<p-dialog [(visible)]="showLabelMatchDialog" modal="true" [style]="{width: '500px'}" [closable]="false"
          [closeOnEscape]="false">
  <ng-template #header>
    Verify Name and Date of Birth
  </ng-template>
  <div>
    <p>
      Verify that the name and DOB on the electronic order match the package that was scanned in Labtek. If they match,
      click Continue. Otherwise, Cancel.
    </p>
  </div>
  <div class="compare-container">
    <div class="compare-column">
      <b>Electronic Order</b>
      <div>Name: {{medtekOrder.PatientFirstName}} {{medtekOrder.PatientLastName}}</div>
      <div>Birth Date {{medtekOrder.PatientBirthDate | date: 'MM/dd/yyyy'}}</div>
    </div>
    <div class="compare-column">
      <b>Labtek</b>
      <div>Name: {{requisition.FirstName}} {{requisition.LastName}}</div>
      <div>Birth Date: {{requisition.BirthDate | date: 'MM/dd/yyyy'}}</div>
    </div>
  </div>

  <div class="grid p-jc-center">
    <p-button (onClick)="confirmLabelMatch()" icon="pi pi-check" label="Continue" class="p-m-2"></p-button>
    <p-button (onClick)="cancelLabelMatch()" icon="pi pi-check" label="Cancel" class="p-m-2"></p-button>
  </div>
</p-dialog>
